import { CouponStatusId } from '../../../../../types/enums/giftVoucher-enums';

export const translationKeys = [
    'giftVoucher.couponCode',
    'giftVoucher.startDate',
    'giftVoucher.endDate',
    'giftVoucher.status',
    'giftVoucher.type',
    'giftVoucher.amount',
    'giftVoucher.maxAmount',
    'giftVoucher.minAmount',
    'giftVoucher.description',
    'general.actions',
];

export const fieldNames = [
    'couponCode',
    'startDate',
    'endDate',
    'status',
    'couponType',
    'value',
    'maxDiscountAmount',
    'minOrderGrandTotalAmount',
    'description',
];

export const statusOptions = [
    {
        id: CouponStatusId.PendingForApproval,
        name: 'giftVoucher.couponStatus.pendingForApproval',
    },
    {
        id: CouponStatusId.Active,
        name: 'giftVoucher.couponStatus.active',
    },
    {
        id: CouponStatusId.Passive,
        name: 'giftVoucher.couponStatus.passive',
    },
    {
        id: CouponStatusId.Expired,
        name: 'giftVoucher.couponStatus.expired',
    },
    {
        id: CouponStatusId.Exhausted,
        name: 'giftVoucher.couponStatus.exhausted',
    },
    {
        id: CouponStatusId.Cancelled,
        name: 'giftVoucher.couponStatus.cancelled',
    },
    {
        id: CouponStatusId.Refunded,
        name: 'giftVoucher.couponStatus.refunded',
    },
    {
        id: CouponStatusId.Deleted,
        name: 'giftVoucher.couponStatus.deleted',
    },
];

export const voucherTypes = [
    {
        id: 1,
        key: 'amount',
    },
    {
        id: 2,
        key: 'percentage',
    },
];

export const sortValues = [
    {
        id: 1,
        name: 'giftVoucher.sortingOptions.descending',
    },
    {
        id: 0,
        name: 'giftVoucher.sortingOptions.ascending',
    },
];

export const sortingOptions = [
    {
        name: 'giftVoucher.sortingOptions.createDate',
        sortKey: 'id',
    },
    {
        name: 'giftVoucher.couponCode',
        sortKey: 'couponCode',
    },
    {
        name: 'giftVoucher.startDate',
        sortKey: 'startDate',
    },
    {
        name: 'giftVoucher.endDate',
        sortKey: 'endDate',
    },
    {
        name: 'giftVoucher.amount',
        sortKey: 'value',
    },
    {
        name: 'giftVoucher.maxAmount',
        sortKey: 'maxDiscountAmount',
    },
    {
        name: 'giftVoucher.minAmount',
        sortKey: 'minOrderGrandTotalAmount',
    },
];
export interface IGiftVoucherData {
    id?: any;
    startDate?: any;
    endDate?: any;
    status?: any;
    minAmount?: any;
    maxAmount?: any;
    description?: any;
    couponSource?: any;
    value?: any;
    [key: `language-${string}`]: any; // Allow dynamic keys for language fields
}
